import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch, useSelector } from "react-redux";
import { Control } from "../../control/control";
import { ControlGroup } from "../../controlGroup/controlGroup";
import { Select } from "../../select/select";
import { CheckBox } from "../../checkbox/checkbox";
import { setEndDay, setEndMonth, setScheduleEnabled, setStartDay, setStartMonth, } from "../../../features/config/schedule.slice";
const dateMap = {
    january: { days: 31 },
    february: { days: 29 },
    march: { days: 31 },
    april: { days: 30 },
    may: { days: 31 },
    june: { days: 30 },
    july: { days: 31 },
    august: { days: 31 },
    september: { days: 30 },
    october: { days: 31 },
    november: { days: 30 },
    december: { days: 31 },
};
// Use zero-based month numbers in Redux: January = 0, December = 11.
const months = Object.keys(dateMap);
const getDays = (month) => {
    if (month === null)
        return [];
    const monthName = months[month];
    const count = dateMap[monthName]?.days ?? 0;
    return Array.from({ length: count }, (_, index) => index + 1);
};
export const ScheduleSettings = () => {
    const dispatch = useDispatch();
    const schedule = useSelector((state) => state.userSchedule);
    const clearStartDay = () => dispatch(setStartDay(null));
    const clearEndDay = () => dispatch(setEndDay(null));
    const monthOptions = (_jsxs(_Fragment, { children: [_jsx("option", { value: "", children: "Select a month" }), months.map((month, index) => (_jsx("option", { value: index, children: month.charAt(0).toUpperCase() + month.slice(1) }, month)))] }));
    const dayOptions = (month) => (_jsxs(_Fragment, { children: [_jsx("option", { value: "", children: "Select a day" }), getDays(month).map((day) => (_jsx("option", { value: day, children: day }, day)))] }));
    return (_jsxs(_Fragment, { children: [_jsx("h2", { children: "Schedule settings" }), _jsx("p", { children: "These will only be exported if they're enabled and everything is set." }), _jsxs(ControlGroup, { children: [_jsx(Control, { name: "Enable", tooltip: "Should snowfall only run at a certain time of the year?", value: schedule.enabled, reset: () => dispatch(setScheduleEnabled(false)), showOutput: false, onChange: (event) => {
                            const checked = event.target.checked;
                            dispatch(setScheduleEnabled(checked));
                        }, children: _jsx(CheckBox, {}) }), schedule.enabled && (_jsxs(_Fragment, { children: [_jsx(Control, { name: "Start month", tooltip: "The month to start from", value: schedule.from.month ?? "", reset: () => dispatch(setStartMonth(null)), onChange: (event) => {
                                    const value = event.target.value;
                                    dispatch(setStartMonth(value === "" ? null : Number(value)));
                                }, children: _jsx(Select, { children: monthOptions }) }), schedule.from.month !== null && (_jsx(Control, { name: "Start day", tooltip: "The day to start from", value: schedule.from.day ?? "", reset: clearStartDay, onChange: (event) => {
                                    const value = event.target.value;
                                    dispatch(setStartDay(value === "" ? null : Number(value)));
                                }, children: _jsx(Select, { children: dayOptions(schedule.from.month) }) })), schedule.from.month !== null && schedule.from.day !== null && (_jsx(Control, { name: "End month", tooltip: "The month to end on", value: schedule.to.month ?? "", reset: () => dispatch(setEndMonth(null)), onChange: (event) => {
                                    const value = event.target.value;
                                    dispatch(setEndMonth(value === "" ? null : Number(value)));
                                }, children: _jsx(Select, { children: monthOptions }) })), schedule.from.month !== null &&
                                schedule.from.day !== null &&
                                schedule.to.month !== null && (_jsx(Control, { name: "End day", tooltip: "The day to end on", value: schedule.to.day ?? "", reset: clearEndDay, onChange: (event) => {
                                    const value = event.target.value;
                                    dispatch(setEndDay(value === "" ? null : Number(value)));
                                }, children: _jsx(Select, { children: dayOptions(schedule.to.month) }) }))] }))] })] }));
};
